import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import { ParagraphXSmall } from 'baseui/typography';
import React, {Component} from 'react';
import {Button, SIZE, SHAPE, KIND} from 'baseui/button';

const centerProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

class Carousel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            images: this.props.images,
            captions: this.props.captions || [],
            show_index: 0,
            maxWidth: this.props.maxWidth || '350px'
        };

        this.carouselInterval = null;
    }

    nextPhoto = () => {
        if (this.state.show_index >= (this.state.images.length - 1)) {
            this.setState({show_index: 0})
        } else {
            this.setState({show_index: this.state.show_index + 1})
        }
    };

    componentDidMount = () => {
        this.carouselInterval = setInterval(this.nextPhoto, 10000);
    };

    resetInterval = () => {
        clearInterval(this.carouselInterval);
        this.carouselInterval = null;
        this.carouselInterval = setInterval(this.nextPhoto, 10000);
    };

    renderPhoto = () => {
        return <img
            style={{border: '1px solid gray'}}
            src={this.state.images[this.state.show_index]}
            alt={'screenshot'}
            width={this.state.maxWidth}/>
    }

    renderCaption = () => {
        if (this.state.show_index > this.state.captions.length) {
            return null;
        }
        return this.state.captions[this.state.show_index]
    }

    renderButtons = () => {
        return this.state.images.map((image, idx) => <Button
            key={idx}
            size={SIZE.mini}
            shape={SHAPE.circle}
            kind={KIND.secondary}
            isSelected={this.state.show_index === idx}
            onClick={() => {this.resetInterval(); this.setState({show_index: idx});}}
            overrides={{
                BaseButton: {
                    style: ({ $theme }) => ({
                        marginTop: '10px',
                        marginBottom: '5px',
                        marginLeft: '5px',
                        marginRight: '10px',

                        
                    })
                }
            }}
            ></Button>)
    };

    render = () => {
        return <FlexGrid>
            <FlexGridItem {...centerProps}>{this.renderPhoto()}</FlexGridItem>
            <FlexGridItem {...centerProps}>{this.renderButtons()}</FlexGridItem>
            <FlexGridItem {...centerProps}><ParagraphXSmall maxWidth={this.state.maxWidth} style={{textAlign: 'center'}}>{this.renderCaption()}</ParagraphXSmall></FlexGridItem>
        </FlexGrid>
    };
}

export default Carousel;
